// @flow

export const IrKeyMap = {
  CH_UP: 4,
  CH_DOWN: 5,
  '1': 9,
  '2': 10,
  '3': 11,
  '4': 12,
  '5': 13,
  '6': 14,
  '7': 15,
  '8': 16,
  '9': 17,
  '0': 18,
  RECALL: 21,
  STOP: 25,
  RECORD: 29,
  SKIP_FORWARD: 30,
  SKIP_BACKWARD: 31,
  LIVE_TV: 32,
};

export const AustinEvents = {
  // onError: 'onError',
  // onHddConnected: 'onHddConnected',
  // onHddDisconnected: 'onHddDisconnected',
  // onHddPaired: 'onHddPaired',
  // onHddRecordingEnabled: 'onHddRecordingEnabled',
  // onInfo: 'onInfo',
  // onPause: 'onPause',
  // onPlaying: 'onPlaying',
  // onPopUp: 'onPopUp',
  // onReady: 'onReady',
  // onStallEnd: 'onStallEnd',
  // onStallStart: 'onStallStart',
  // onStatusChange: 'onStatusChange',
  // onTimeUpdate: 'onTimeUpdate',
  /**
   * This event will be fired when there is a state change in Austin. eg: connecting -> connected
   */
  onStatusChange: 'onStatusChange',
  /**
   * This event will be fired when there is an error occurred in Austin
   */
  onError: 'onError',
  /**
   * This event will be fired when there is an info message available in Austin. eg: stream discontinuity
   */
  onInfo: 'onInfo',
  /**
   * This event will be fired when a box pop-up has to be shown to user.
   * Popup will have type, message, buttons(optional) and input(optional).
   * Buttons will have list of button each having a text, url and a payload.
   * Sample popUp data :
   * <pre>
   * {
   *      'type': 'generic'/'dismiss'/'info'/'landing_page',
   *      'message': 'Your request can only be carried out in Live mode..Switch to live mode now?',
   *      'buttons': [...buttonInfo], //list of buttonInfo, Sample json has been listed below
   *      'input': {
   *          'type': 'text'/'password',
   *          'placeholder': 'placeholder text'
   *          }
   *  }
   *  </pre>
   *
   *   a.) 'generic' is for multiple use cases like when user dvr streaming is about to reach end,
   *  user tries to switch channel in delayedLive mode, user has to enter password for locked channel etc. <br/>
   *   b.) 'dismiss' is for dismissing any active popup. <br/>
   *   c.) 'info' does not have to show any popup. For this a notification can be shown to user if required. <br/>
   *   d.) 'landing_page' show the status to all tuners and giver user option to join any tuner. <br/>
   *
   * For few pop-up event data, input details will be available when user is required to give input like password, channel etc.
   * Once user click on a popup button, popUpUserAction API is called with exactly same button details and user input if required.
   *
   * <br/>Sample json for buttonInfo
   * <pre>
   *     {    text: "START OVER",
   *          url: "START_OVER/rest/v1/receiverid/:_receiverid?correlationid=:_correlationid",
   *          payload: "START_OVER&creator=0" }
   * </pre>
   */
  onPopUp: 'onPopUp',
  /**
   * This event will be fired on Buffering start
   */
  onStallStart: 'onStallStart',
  /**
   * This event will be fired on Buffering complete
   */
  onStallEnd: 'onStallEnd',
  /**
   * This event will be fired on pausing the playback
   */
  onPause: 'onPause',
  /**
   * This event will be fired on starting the streaming playback
   */
  onPlaying: 'onPlaying',
  /**
   * This event will be fired on when Austin is ready to playback
   */
  onReady: 'onReady',
  /**
   * This event will be fired on time progress of the playback
   */
  onTimeUpdate: 'onTimeUpdate',
  /**
   * This event will be fired on connecting Hard Disk to Box
   */
  onHddConnected: 'onHddConnected',
  /**
   * This event will be fired on pairing Hard Disk with Box
   */
  onHddPaired: 'onHddPaired',
  /**
   * this event will be fired on dis-connecting Hard Disk from Box
   */
  onHddDisconnected: 'onHddDisconnected',
  /**
   * This event will be fired when recording is enabled with Hard Disk connected to Box
   */
  onHddRecordingEnabled: 'onHddRecordingEnabled',
};

export const AustinEventsInternal = {
  // Internal events emitted after processing from box events polling response
  BOX_READY: 'boxReady',
  BOX_BUFFER_BAR: 'boxBufferBar',
  BOX_CONNECTION_LOST: 'boxConnectionLost',
  BOX_DISCONTINUITY_HANDLED: 'boxDiscontinuityHandled',
  BOX_DVR_END: 'boxDvrEnd',
  BOX_POP_UP: 'boxPopUp',
  BOX_STREAM_DISCONTINUITY: 'boxStreamDiscontinuity',
  BOX_STREAM_LOST: 'boxStreamLost',
  BOX_STREAM_STOP: 'boxStreamStop',
  BOX_VIDEO_LOCK_LOST: 'boxVideoLockLost',
  BOX_VIDEO_SIGNAL: 'boxVideoSignal',
  // Internal events emitted from PLAYER Wrapper
  PLAYER_ERROR: 'playerError',
  PLAYER_STALL_START: 'playerStallStart',
  PLAYER_STALL_END: 'playerStallEnd',
  PLAYER_READY: 'playerReady',
  PLAYER_PAUSE: 'playerPause',
  PLAYER_PLAY: 'playerPlay',
  PLAYER_PLAYING: 'playerPlaying',
  PLAYER_FIRST_FRAME_RENDERED: 'playerFirstFrameRendered',
  PLAYER_TIME_UPDATE: 'playerTimeUpdate',
  PLAYER_SUBTITLE_ADDED: 'playerSubtitleAdded',
  PLAYER_WARNING: 'playerWarning',
};

/**
 *  1. disconnected      - Austin is in disconnected state with Box
 *  2. connecting        - Austin is in trying to connect with Box
 *  3. connected         - Austin is in connected state with Box
 *  4. startingStreaming - Austin is starting streaming with Box
 *  5. stoppingStreaming - Austin is stopping streaming with Box
 *  6. streaming         - Austin is in streaming state with Box
 *  7. noVideoSignal     - Austin has revived No Video Signal from the Box
 *  8. tooManyStreams    - Max. concurrent streaming supported limit reached on Box
 *  9. streamLost        - Ongoing streaming is lost with Box.
 */
export const AustinStatus = {
  DISCONNECTED: 'disconnected',
  DISCONNECTING: 'disconnecting',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  STARTING_STREAMING: 'startingStreaming',
  STOPPING_STREAMING: 'stoppingStreaming',
  STREAMING: 'streaming',
  NO_VIDEO_SIGNAL: 'noVideoSignal',
};

export const AustinErrors = {
  // Client errors
  ALREADY_CONNECTED: 'alreadyConnected',
  ALREADY_IN_CONNECTING: 'alreadyInConnecting',
  AUSTIN_NOT_INITIALIZED: 'austinNotInitialized',
  CLIENT_CONNECTIVITY_PROBLEM: 'clientConnectivityIssue',
  DISCONNECT_REQUESTED: 'disconnectRequested',
  HTML5_PLAYBACK_NOT_SUPPORTED: 'html5PlaybackNotSupported',
  INVALID_CREATE_SESSION_PARAM: 'invalidCreateSessionParam',
  HDD_NOT_CONNECTED: 'hddNotConnected',
  MISSING_PLATFORM: 'missingPlatform',
  NOT_ALLOWED: 'notAllowed',
  NOT_ALLOWED_HDD_NOT_CONNECTED: 'notAllowedHddNotConnected',
  NOT_CONNECTED: 'notConnected',
  NOT_STREAMING: 'notStreaming',
  NO_STREAMING_FOUND: 'noStreamingFound',
  TIMEOUT: 'timeout',
  // Austin API errors : More details/root cause ie. error object received in Austin, will be added in info
  API_FAILED: 'apiFailed',
  AJAX_REQUEST_FAILED: 'ajaxRequestFailed',
  AUTHORIZATION_FAILED: 'authorizationFailed',
  BOX_NOT_READY: 'boxNotReady',
  BOX_IN_BAD_STATE: 'boxInBadState',
  BOX_OFFLINE: 'boxOffline',
  BOX_ONLINE_BUT_UNREACHABLE: 'boxOnlineButUnreachable',
  CONNECT_FAILED: 'connectFailed',
  CONFLICT_RECORDINGS: 'conflictRecordings',
  CREATE_SESSION_FAILED: 'createSessionFailed',
  CREATE_RELAY_INSTANCE_FAILED: 'createRelayInstanceFailed',
  DUPLICATE_ACTIVE_RECORDING: 'duplicateActiveRecording',
  DUPLICATE_CONFLICTS: 'duplicateConflicts',
  DUPLICATE_TIMER: 'duplicateTimer',
  EXPIRED_SESSION_RESPONSE: 'expiredSessionResponse',
  FETCH_SPARCS_FAILED: 'fetchSparcsFailed',
  INVALID_CONTENT_TYPE: 'invalidContentType',
  INVALID_RI_RESPONSE: 'invalidRIResponse',
  INVALID_SPARCS_RESPONSE: 'invalidSparcsResponse',
  LEGACY_BOX_HTML5_DASH_UNSUPPORTED: 'legacyBoxHtml5DashUnsupported',
  MISSING_PLAYER_CONTAINER_ID_OR_ELEMENT: 'missingPlayerContainerIdOrElement',
  MISSING_STREAMING_LINK: 'missingStreamingLink',
  MISSING_LICENCE_URL: 'missingLicenceUrl',
  NO_VIDEO_SIGNAL: 'noVideoSignal',
  STREAM_LOST: 'streamLost',
  TOO_MANY_STREAMS: 'tooManyStreams',
  START_STREAM_REQUEST_TIMEOUT: 'startStreamRequestTimeout',
  UNKNOWN_ERROR: 'unknownError',
  UNREACHABLE_SPARCS: 'unreachableSparcs',
  UNREGISTERED_SPARCS: 'unregisteredSparcs',
  UNSUPPORTED_FIRMWARE: 'unsupportedFirmware',
  // Player errors : More details/root cause ie. error object received from bitDash or dashJs, will be added in info
  PLAYER_ERROR: 'playerError',
  PLAYER_ERROR_WHILE_STREAMING: 'playerErrorWhileStreaming',
  // message text for detailed description
  INVALID_PARAMS: 'Client did not pass valid parameters',
  TUNE_FAILED: 'tuneFailed',
};

export const AustinSTBErrors = {
  CONNECTION_LOST: 'connectionLost',
  FORCE_TRANSFER: 'forceTransfer',
  ME_REBOOT: 'meReboot',
  SIGNAL_LOST: 'signalLost',
};

export const AustinDRMErrors = {
  DRM_LICENCE_FETCH_FAILED: 'EME DRM Error: licence fetch failed',
  DRM_SET_MEDIA_KEYS_FAILED: 'EME DRM Error: setMediaKeys failed',
  DRM_LICENCE_UPDATE_FAILED: 'EME DRM Error: licence update failed',
  DRM_LICENCE_FETCH_WV_PROXY_ACCESS_DENIED: 'EME DRM Error: wv proxy access denied',
};

/**
 * Bitmovin Player Events
 */
export const PlayerEvent = {
  AdBreakStarted: 'adbreakstarted',
  AdBreakFinished: 'adbreakfinished',
  AdClicked: 'adclicked',
  AdFinished: 'adfinished',
  AdLinearityChanged: 'adlinearitychanged',
  AdManifestLoaded: 'admanifestloaded',
  AdSkipped: 'adskipped',
  AdStarted: 'adstarted',
  AdQuartile: 'adquartile',
  AdError: 'aderror',
  AirplayAvailable: 'airplayavailable',
  AirplayChanged: 'airplaychanged',
  AudioAdaptation: 'audioadaptation',
  AudioAdded: 'audioadded',
  AudioChanged: 'audiochanged',
  AudioDownloadQualityChange: 'audiodownloadqualitychange',
  AudioDownloadQualityChanged: 'audiodownloadqualitychanged',
  AudioPlaybackQualityChanged: 'audioplaybackqualitychanged',
  AudioRemoved: 'audioremoved',
  AudioQualityChanged: 'audioqualitychanged',
  CastAvailable: 'castavailable',
  CastStart: 'caststart',
  CastStarted: 'caststarted',
  CastStopped: 'caststopped',
  CastWaitingForDevice: 'castwaitingfordevice',
  CueEnter: 'cueenter',
  CueExit: 'cueexit',
  CueParsed: 'cueparsed',
  CueUpdate: 'cueupdate',
  Destroy: 'destroy',
  DownloadFinished: 'downloadfinished',
  DVRWindowExceeded: 'dvrwindowexceeded',
  Error: 'error',
  Metadata: 'metadata',
  MetadataParsed: 'metadataparsed',
  ModuleReady: 'moduleready',
  Muted: 'muted',
  OverlayAdStarted: 'overlayadstarted',
  Paused: 'paused',
  PeriodSwitch: 'periodswitch',
  PeriodSwitched: 'periodswitched',
  Play: 'play',
  PlaybackFinished: 'playbackfinished',
  PlaybackSpeedChanged: 'playbackspeedchanged',
  PlayerResized: 'playerresized',
  Playing: 'playing',
  Ready: 'ready',
  Seek: 'seek',
  Seeked: 'seeked',
  SegmentPlayback: 'segmentplayback',
  SegmentRequestFinished: 'segmentrequestfinished',
  ShowAirplayTargetPicker: 'showairplaytargetpicker',
  SourceLoaded: 'sourceloaded',
  SourceUnloaded: 'sourceunloaded',
  SubtitleAdded: 'subtitleadded',
  SubtitleDisable: 'subtitledisable',
  SubtitleDisabled: 'subtitledisabled',
  SubtitleEnable: 'subtitleenable',
  SubtitleEnabled: 'subtitleenabled',
  SubtitleRemoved: 'subtitleremoved',
  StallEnded: 'stallended',
  StallStarted: 'stallstarted',
  TimeChanged: 'timechanged',
  TimeShift: 'timeshift',
  TimeShifted: 'timeshifted',
  Unmuted: 'unmuted',
  VideoAdaptation: 'videoadaptation',
  VideoDownloadQualityChange: 'videodownloadqualitychange',
  VideoDownloadQualityChanged: 'videodownloadqualitychanged',
  VideoPlaybackQualityChanged: 'videoplaybackqualitychanged',
  VideoQualityChanged: 'videoqualitychanged',
  ViewModeChanged: 'viewmodechanged',
  VolumeChanged: 'volumechanged',
  VRStereoChanged: 'vrstereochanged',
  VRViewingDirectionChange: 'vrviewingdirectionchange',
  VRViewingDirectionChanged: 'vrviewingdirectionchanged',
  Warning: 'warning',
};

/**
 * Custom Player Events used in Bitmovin UI
 */
export const PlayerCustomEvent = {
  ChannelDown: 'channelDown',
  ChannelUp: 'channelUp',
  Live: 'live',
  Pause: 'slingPause',
  Play: 'slingPlay',
  Record: 'record',
  Reload: 'reload',
  Seek: 'slingSeek',
  SkipBackward: 'skipBackward',
  SkipForward: 'skipForward',
  Unload: 'unload',
};

export const PlayerMessages = {
  changing_channel: 'Changing channel...',
  connected: 'Successfully connected to your receiver...',
  connecting: 'Connecting to your receiver...',
  noVideoSignal: 'Connection lost...',
  startingStreaming: 'Starting streaming...',
  stoppingStreaming: 'Stopping streaming...',
  streaming: 'Streaming...',
  connectionReEstablishing: 'Re-establishing connection...',
};

export const SlingError = {
  Austin: 'austin',
  AustinOnError: 'austinOnErrorEvent',
  Connect: 'connect',
  WebView: 'webView',
  Play: 'playerror',
};

/**
 * Sling functionality
 */
export const SlingEvent = {
  AsyncData: 'async',
  AustinCall: 'austincall',
  AustinEvent: 'austinevent',
  BitmovinCall: 'bitmovin',
  BitmovinEvent: 'bitmovinplayer',
  Connect: 'connect',
  Connected: 'connected',
  Destroy: 'austinDestroy',
  Error: 'error',
  HandlePopUp: 'handlePopUp',
  Init: 'init',
  ReInit: 'reinit',
  IRCommand: 'ir',
  Load: 'stream',
  Log: 'log',
  Play: 'play',
  PlaybackInfo: 'playbackinfo',
  PlayerConfig: 'playerConfig',
  PlayerControlEvent: 'playerControl',
  SetTargetLevel: 'setTargetLevel',
  Stop: 'stop',
  StopStreaming: 'stopStreaming',
  ToggleFullscreen: 'toggleFullscreen',
  TogglePlay: 'togglePlay',
  Unload: 'austin_unload',
};

/**
 * Bitmovin Player BufferType
 */
export const BufferType = {
  BackwardDuration: 'backwardduration',
  ForwardDuration: 'forwardduration',
};

/**
 * Bitmovin Player LogLevel
 */
export const LogLevel = {
  DEBUG: 'debug',
  ERROR: 'error',
  LOG: 'log',
  OFF: 'off',
  WARN: 'warn',
};

/**
 * Bitmovin Player MediaType
 */
export const MediaType = {
  Audio: 'audio',
  Subtitles: 'subtitles',
  Video: 'video',
};

export const PlayerErrors = {
  DRM_FAILED_LICENSE_REQUEST: 'DRM_FAILED_LICENSE_REQUEST',
  NETWORK_ERROR: 'NETWORK_ERROR',
  ACCESS_DENIED: 'ACCESS_DENIED',
  CONNECTION_LOST: 'CONNECTION_LOST',
};

/**
 * DebugInfo Button Types
 */
export const InfoTypes = {
  STREAM: 'stream',
  BOX: 'box',
  DEVICE: 'device,',
};
